import axios from "axios";

export default function getAvailableBranches(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/account/api/v1/branch-group/available-branch?branch_group_uuid=${uuid}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
